import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  heading: {
    margin: "1rem 0rem 1rem 0rem",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    color: "#5F5F5F",
    fontWeight: "600",
    fontSize: "1.125rem",
    lineHeight: "2.5rem",
    letterSpacing: "0.08rem",
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.125rem",
      lineHeight: "2rem",
    },
    textAlign: "center",
  },
  text: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
}));

const SectionOne = () => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div className={classes.text}>
        <Typography variant="h1" component="h1" className={classes.heading}>
          The Garden of Eden to transform your reality
        </Typography>
      </div>
    </React.Fragment>
  );
};

export default SectionOne;
